import { getCoreConfig } from "../config";

const ENV_PREFIX = "VITE_";

export const ENVIRONMENTS = {
  PRODUCTION: "production",
  STAGING: "staging",
  DEVELOP: "develop",
  LOCAL: "local",
} as const;

export const getEnvironmentVariableByName = (name: string): string => {
  const env = window?.__ENVS__?.[name];
  if (!env) {
    // we are working locally
    return import.meta.env[`${ENV_PREFIX}${name}`] as string;
  }
  return env;
};

export const isLocal = window.getEnv() === ENVIRONMENTS.LOCAL;
export const isProd = window.getEnv() === ENVIRONMENTS.PRODUCTION;
export const isStaging = window.getEnv() === ENVIRONMENTS.STAGING;
export const isDev = window.getEnv() === ENVIRONMENTS.DEVELOP;

export const getAppName = () => getCoreConfig().appName;
export const getAppVersion = () => getCoreConfig().appVersion;

export const shouldRedirectToNotFound = (
  path: string,
  allowedPaths: string[],
) => {
  const pathsList = (allowedPaths || []).map(p => p.trim()).filter(p => p);

  const pathIsAllowed = pathsList.includes(path);
  // redirect if path is not allowed
  return !pathIsAllowed;
};

export const getHomePageByEnvironment = () => {
  return getEnvironmentVariableByName("DOMAIN_NAME");
};

export const areAnalyticsEnabled =
  getEnvironmentVariableByName("ENABLE_ANALYTICS") === "true";
